import {Observer} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {
	constructor() {
		this.header = document.querySelector(".nav-main-sticky");
		if (this.header) {
			// this.navMain = this.header.querySelector(".navs");
			this.headerClass = this.header.className.replace("is-on-top", "");
			this.toggleHeader();
			this.resize();
		}
		GlobalVariables.resizeCallbacks.push(this);
	}

	getBreakpoint() {
		const rootStyle = getComputedStyle(document.documentElement);
		const breakpoint = rootStyle.getPropertyValue('--nav-breakpoint').trim();

		return parseInt(breakpoint);
	}

	toggleHeader() {
		Observer.create({
			type: "scroll",
			// tolerance: 60,
			// dragMinimum: 30,
			onStop: () => {
				if (window.scrollY < 100) {
					this.header.className = this.headerClass;
					this.header.classList.add("is-on-top");
				} else {
					this.header.classList.remove("is-on-top");
				}
			},
			onStopDelay: 0,
			onUp: () => {
				this.showHeader();
			},
			onDown: () => {
				this.hideHeader();
			},
		});

		if (window.innerWidth > this.getBreakpoint()) {
			setTimeout(() => {
				if (window.scrollY > 100) {
					this.hideHeader();
				}
			}, 0);
		}
	}

	hideHeader() {
		this.header.className = this.headerClass + " hide ";
		document.body.classList.remove("nav-main-show");
	}

	showHeader() {
		this.header.classList.remove("hide");
		document.body.classList.add("nav-main-show");
	}

	resize() {
		if (window.innerWidth > this.getBreakpoint()) {
			document.body.classList.remove("navs-open");
			GlobalVariables.lenis?.start();
		}
	}
}
